// @owners { team: patients }
import { type Brand, getBrand } from '@alto/design-system';
import { IMG_ALT_TEXTS } from '~shared/constants';

type ImageAltKey = keyof typeof IMG_ALT_TEXTS;

// Alt text for images whose per-brand asset differs from the alto original. Only list keys
// whose brand asset no longer matches the shared IMG_ALT_TEXTS description. Kept here rather
// than in each brand's image module so the lookup stays synchronous on web, where the brand
// image modules are lazy-loaded.
const ALT_TEXT_OVERRIDES_BY_BRAND: Record<Brand, Partial<Record<ImageAltKey, string>>> = {
  alto: {},
  fuzerx: {
    addFamilyMember: 'Photo of a mother hugging her daughter',
    addMedication: 'Illustration of a plus sign over a pill bottle',
    autoRefillEmpty: 'Illustration of two circular arrows in a blue circle',
    deliveryCourierWithPatient: 'Photo of a woman laughing',
    helpBubble: 'Illustration of two overlapping chat bubbles',
    location: 'Illustration of two overlapping map pins',
  },
  fuzehealth: {},
};

// Resolves alt text through the same getBrand() call that selects the brand's image set, so the
// description can't drift from the asset actually rendered.
export const getImageAltText = (imageName: ImageAltKey): string =>
  ALT_TEXT_OVERRIDES_BY_BRAND[getBrand()][imageName] ?? IMG_ALT_TEXTS[imageName];
